<template>
    <div>
        <VJoyLabel>{{ $t('profile.preferences.modal.location.address.title') }}</VJoyLabel>
        <LocationAutocomplete v-model="model" :disabled="false" :invalid="errors.length > 0" />
        <VJoyFormError v-if="errors.length" class="joy-mt-2" :errors="errors" data-testid="profile-edition-section-location-error" />
    </div>
</template>

<script setup lang="ts">
    import {VJoyFormError, VJoyLabel} from '@maltjoy/core-vue';
    import type {PostalAddress} from '@api';
    import LocationAutocomplete from '~/components/LocationAutocomplete.vue';

    const model = defineModel<Partial<PostalAddress>>({required: true});
    defineProps<{
        errors: string[];
    }>();
</script>
